
















































import Vue from 'vue';

import MainNavigation from '@/containers/navigation/MainNavigation.vue';
import '@/components/api-error';

export default Vue.extend({
  components: {
    MainNavigation,
  },

  data() {
    return {
      menu: false,
    };
  },

  computed: {
    isAuthenticated(): boolean {
      return this.$store.getters['account/isAuthenticated'];
    },

    hasToken(): boolean {
      return !!this.$store.getters['account/apiToken'];
    },

    isSignedIn(): boolean {
      return this.isAuthenticated;
    },
  },
});
